import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import commonEn from './translation/common.en.json';
import commonEs from './translation/common.es.json';
import commonFr from './translation/common.fr.json';
import cuttingEn from './translation/cutting.en.json';
import cuttingEs from './translation/cutting.es.json';
import cuttingFr from './translation/cutting.fr.json';
import paintingEn from './translation/painting.en.json';
import paintingEs from './translation/painting.es.json';
import paintingFr from './translation/painting.fr.json';
import planEn from './translation/plan.en.json';
import planEs from './translation/plan.es.json';
import planFr from './translation/plan.fr.json';
import weldingEn from './translation/welding.en.json';
import weldingEs from './translation/welding.es.json';
import weldingFr from './translation/welding.fr.json';

enum i18nNamespace {
  COMMON = 'common',
  CUTTING = 'cutting',
  PAINTING = 'painting',
  PLAN = 'plan',
  WELDING = 'welding',
}

const i18nNamespaceSeperator = ':';
export const i18nDefaultNamespace = i18nNamespace.COMMON;
export const i18nResources = {
  en: {
    [i18nNamespace.COMMON]: commonEn,
    [i18nNamespace.CUTTING]: cuttingEn,
    [i18nNamespace.PAINTING]: paintingEn,
    [i18nNamespace.WELDING]: weldingEn,
    [i18nNamespace.PLAN]: planEn,
  },
  es: {
    [i18nNamespace.COMMON]: commonEs,
    [i18nNamespace.CUTTING]: cuttingEs,
    [i18nNamespace.PAINTING]: paintingEs,
    [i18nNamespace.WELDING]: weldingEs,
    [i18nNamespace.PLAN]: planEs,
  },
  fr: {
    [i18nNamespace.COMMON]: commonFr,
    [i18nNamespace.CUTTING]: cuttingFr,
    [i18nNamespace.PAINTING]: paintingFr,
    [i18nNamespace.WELDING]: weldingFr,
    [i18nNamespace.PLAN]: planFr,
  },
} as const;

export type i18nKeyType = string;

type LocalizedTextFieldSupportedLocales = 'en';

export type LocalizedTextField = {
  [local in LocalizedTextFieldSupportedLocales]: string;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    defaultNS: i18nDefaultNamespace,
    ns: Object.keys(i18nResources['en']),
    resources: i18nResources,
    fallbackLng: 'en',
    keySeparator: i18nNamespaceSeperator,
    nsSeparator: i18nNamespaceSeperator,
    detection: {
      // order and from where user language should be detected
      order: [
        'navigator',
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      format: (value: any, format: any, lng: any) => {
        // https://stackoverflow.com/questions/63586596/how-to-format-currency-using-react-i18next-library/63592384#63592384
        switch (format) {
          case 'currency':
            /**
             * Usage: {i18n.t('FORMAT_CURRENCY', { value: { amount: 42, currency: 'USD' } } )}
             * Output: $42.00
             */
            return Intl.NumberFormat(lng, {
              style: 'currency',
              currency: value.currency,
            }).format(value.amount);
        }
        return value;
      },
    },
    supportedLngs: ['en-US', 'fr-CA', 'en', 'es', 'fr'],
  });

export default i18n;
